import Swiper from 'swiper';
import { Navigation, Keyboard, Autoplay, Thumbs, FreeMode, Mousewheel } from 'swiper/modules';

function gallery(config) {

  const galerySliderEl = document.querySelector('.gallery[data-module="slider"] .swiper');

  const galleryThumbnailsConfig = {
    modules: [FreeMode, Mousewheel],
    direction: 'vertical',
    mousewheel: true,
    effect: 'slide',
    loop: true,
    slidesPerView: 4,
    spaceBetween: 10,
    freeMode: true,
    watchSlidesProgress: true,
  }

  var galleryThumbnailsSwiper = new Swiper('.gallery-thumbnails .swiper', galleryThumbnailsConfig);


  const galleryConfig = {
    modules: [Navigation, Keyboard, Autoplay, Thumbs,],
    direction: 'vertical',
    effect: 'slide',
    loop: true,
    spaceBetween: 10,
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },
    navigation: {
      nextEl: '.gallery[data-module="slider"] .slider-btn-next',
      prevEl: '.gallery[data-module="slider"] .slider-btn-prev',
    },
    thumbs: {
      swiper: galleryThumbnailsSwiper,
    },
  }



  var gallerySwiper = new Swiper(galerySliderEl, galleryConfig);
  // config.direction = 'vertical';

  if (galerySliderEl) {
    return gallerySwiper
  }
  return
}

function openMediaInModal() {

  const el = {
    video: {
      modal: document.querySelector('#video-gallery'),
      iframe: document.querySelector('#video-gallery iframe'),
      ttl: document.querySelector('#video-gallery .ttl'),
      desc: document.querySelector('#video-gallery .desc')
    },
    image: {
      modal: document.querySelector('#image-gallery'),
      box: document.querySelector('#image-gallery .media-wrapper'),
      ttl: document.querySelector('#image-gallery .ttl'),
      desc: document.querySelector('#image-gallery .desc')
    }
  }

  document.querySelectorAll('.gallery .swiper-slide .img')?.forEach(slide => {
    slide.addEventListener('click', function (e) {
      if (slide.dataset.image) {
        el.image.box.style.backgroundImage = 'url(' + slide.dataset.imageUrl + ')';
        el.image.ttl.textContent = slide.dataset.ttl;
        el.image.desc.textContent = slide.dataset.desc;
      } else {
        el.video.ttl.textContent = slide.dataset.ttl;
        el.video.desc.textContent = slide.dataset.desc;
      }
    })
  })
}

export {
  gallery,
  openMediaInModal
}
